/** Cuantos organos sanos hacen falta para ganar. */
export const ORGANS_TO_WIN = 4;
/** Cartas en mano al empezar el turno. */
export const HAND_SIZE = 3;
export function organStatus(pile) {
    if (pile.viruses.length > 0)
        return 'infected';
    if (pile.medicines.length >= 2)
        return 'immunized';
    if (pile.medicines.length === 1)
        return 'vaccinated';
    return 'free';
}
/** Sano = libre, vacunado o inmunizado (es decir, sin virus encima). */
export function isHealthy(pile) {
    return pile.viruses.length === 0;
}
/** El comodin encaja con cualquier color; el resto solo consigo mismo. */
export function colorsMatch(a, b) {
    if (!a || !b)
        return false;
    return a === 'wild' || b === 'wild' || a === b;
}
export function findPlayer(state, playerId) {
    return state.players.find((p) => p.id === playerId);
}
export function findPile(state, ref) {
    return findPlayer(state, ref.playerId)?.body.find((p) => p.organ.id === ref.organId);
}
/** No se pueden tener dos organos del mismo color (el quimerico cuenta como color propio). */
export function canReceiveOrganColor(player, color, ignoreOrganId) {
    return !player.body.some((p) => p.organ.color === color && p.organ.id !== ignoreOrganId);
}
export function healthyOrganCount(player) {
    return player.body.filter(isHealthy).length;
}
export function hasWon(player) {
    return healthyOrganCount(player) >= ORGANS_TO_WIN;
}
export function cardById(hand, cardId) {
    return hand.find((c) => c.id === cardId);
}
//# sourceMappingURL=rules.js.map